var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoPermissionsGraphicDarkMode = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_1495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.8125 76.5625H67.1875C65.4641 76.5625 64.0625 75.1609 64.0625 73.4375V70.3125C64.0625 68.5891 65.4641 67.1875 67.1875 67.1875H82.8125C84.5359 67.1875 85.9375 68.5891 85.9375 70.3125V73.4375C85.9375 75.1609 84.5359 76.5625 82.8125 76.5625Z",
    fill: "#EB6087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8125 89.0625H67.1875C65.4641 89.0625 64.0625 87.6609 64.0625 85.9375V82.8125C64.0625 81.0891 65.4641 79.6875 67.1875 79.6875H82.8125C84.5359 79.6875 85.9375 81.0891 85.9375 82.8125V85.9375C85.9375 87.6609 84.5359 89.0625 82.8125 89.0625Z",
    fill: "#EB6087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8125 76.5625H67.1875C65.4641 76.5625 64.0625 75.1609 64.0625 73.4375V70.3125C64.0625 68.5891 65.4641 67.1875 67.1875 67.1875H82.8125C84.5359 67.1875 85.9375 68.5891 85.9375 70.3125V73.4375C85.9375 75.1609 84.5359 76.5625 82.8125 76.5625Z",
    fill: "#EB6087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8125 64.0625H67.1875C65.4641 64.0625 64.0625 62.6609 64.0625 60.9375V57.8125C64.0625 56.0891 65.4641 54.6875 67.1875 54.6875H82.8125C84.5359 54.6875 85.9375 56.0891 85.9375 57.8125V60.9375C85.9375 62.6609 84.5359 64.0625 82.8125 64.0625Z",
    fill: "#EB6087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6875 89.0625H42.1875V79.6875H54.6875V89.0625Z",
    fill: "#EB6087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5625 89.0625C23.1156 89.0625 20.3125 86.2594 20.3125 82.8125C20.3125 79.3656 23.1156 76.5625 26.5625 76.5625C30.0094 76.5625 32.8125 79.3656 32.8125 82.8125C32.8125 86.2594 30.0094 89.0625 26.5625 89.0625Z",
    fill: "#EB6087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 95.3125H60.9375V48.4375H75C77.5844 48.4375 79.6875 50.5406 79.6875 53.125V54.6875H82.8125V53.125C82.8125 49.3531 80.1234 46.1969 76.5625 45.4703V29.6875C76.5625 14.1797 63.9453 1.5625 48.4375 1.5625C32.9297 1.5625 20.3125 14.1797 20.3125 29.6875V45.4703C16.7516 46.1969 14.0625 49.3531 14.0625 53.125V90.625C14.0625 94.9328 17.5672 98.4375 21.875 98.4375H75C79.3078 98.4375 82.8125 94.9328 82.8125 90.625V89.0625H79.6875V90.625C79.6875 93.2094 77.5844 95.3125 75 95.3125ZM57.8125 95.3125H39.0625V48.4375H57.8125V95.3125ZM64.0625 45.3125H32.8125V29.6875C32.8125 21.0719 39.8219 14.0625 48.4375 14.0625C57.0531 14.0625 64.0625 21.0719 64.0625 29.6875V45.3125ZM48.4375 4.6875C62.2219 4.6875 73.4375 15.9031 73.4375 29.6875V45.3125H67.1875V29.6875C67.1875 19.3484 58.7766 10.9375 48.4375 10.9375C38.0984 10.9375 29.6875 19.3484 29.6875 29.6875V45.3125H23.4375V29.6875C23.4375 15.9031 34.6531 4.6875 48.4375 4.6875ZM17.1875 90.625V53.125C17.1875 50.5406 19.2906 48.4375 21.875 48.4375H35.9375V95.3125H21.875C19.2906 95.3125 17.1875 93.2094 17.1875 90.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6875 76.5625H82.8125V79.6875H79.6875V76.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6875 64.0625H82.8125V67.1875H79.6875V64.0625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3125 79.6875H73.4375V89.0625H70.3125V79.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5625 79.6875H79.6875V89.0625H76.5625V79.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3125 67.1875H73.4375V76.5625H70.3125V67.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5625 67.1875H79.6875V76.5625H76.5625V67.1875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3125 54.6875H73.4375V64.0625H70.3125V54.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5625 54.6875H79.6875V64.0625H76.5625V54.6875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_1495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoPermissionsGraphicDarkMode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no-permissions-graphic-dark-mode.219dd2ed32000e425092ca4e0b89e580.svg";